export const TOPICS_RESET_STATE = 'TOPICS_RESET_STATE';
export const TOPICS_CURRENT_ITEM = 'TOPICS_CURRENT_ITEM';

export const TOPICS_REQUEST_LOADING = 'TOPICS_REQUEST_LOADING';
export const TOPICS_REQUEST_SUCCESS = 'TOPICS_REQUEST_SUCCESS';
export const TOPICS_REQUEST_FAILED = 'TOPICS_REQUEST_FAILED';

export const TOPICS_CURRENT_ACTION = 'TOPICS_CURRENT_ACTION';
export const TOPICS_RESET_ACTION = 'TOPICS_RESET_ACTION';